import { render } from "./AddPlotModal.vue?vue&type=template&id=6c635071&scoped=true"
import script from "./AddPlotModal.vue?vue&type=script&lang=js"
export * from "./AddPlotModal.vue?vue&type=script&lang=js"

import "./AddPlotModal.vue?vue&type=style&index=0&id=6c635071&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c635071"]])

export default __exports__